import EDC from '../../../shared/globals';
import CategoryItem from '../item/category-item';
import TaskItem from '../item/task-item';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.CategorizationSimpleFrame.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.CategorizationSimpleFrame.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.taskItem = null;
  this.iterationsData = null;
  this.categoryItems = [];
};

// eslint-disable-next-line max-len
EDC.Games.CategorizationSimpleFrame.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.CategorizationSimpleFrame.Scenes.Main.prototype.constructor = EDC.Games.CategorizationSimpleFrame.Scenes.Main;

const CWIAN = EDC.Games.CategorizationSimpleFrame.Scenes.Main.prototype;

CWIAN.create = function () {
  this.initialize();
  this.loadData();

  this.add.sprite(this.game.config.width / 2, 1020, 'title');

  this.loadIteration();

  this.createBasicUI();
};

CWIAN.createCategories = function () {
  const { categoriesNames } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { categories } = this.gameConfig;
  let index = 0;
  const SLOT_WIDTH = this.game.config.width / categoriesNames.length;
  const array = [];
  for (let i = 0; i < categories.length; i++) {
    for (let j = 0; j < categoriesNames.length; j++) {
      if (categories[i].id === categoriesNames[j]) {
        array.push(categories[i]);
      }
    }
  }
  for (let i = 0; i < array.length; i++) {
    const data = array[i];
    const slotX = SLOT_WIDTH * index;
    // eslint-disable-next-line max-len
    this.categoryItems.push(new CategoryItem(this, data.text, data.id).create(slotX, SLOT_WIDTH, 50, 0.95));
    index += 1;
  }
};
/**
 *
 */
CWIAN.createItem = function () {
  this.taskItem = new TaskItem(this).create();
};
/**
 *
 */
CWIAN.loadIteration = function () {
  this.createCategories();
  this.createItem();
  const data = this.iterationsData;
  this.taskItem.update(data.text, `${data.categoryId}-${data.itemId}`);
};
/**
 *
 */

CWIAN.loadNextIteration = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.iterationsData = null;
    this.taskItem.deleteObject();
    this.taskItem = null;
    this.categoryItems.map((x) => {
      x.deleteObject();
      return true;
    });
    this.categoryItems = [];
    this.loadData();
    this.createCategories();
    this.createItem();
    this.loadIteration();
  }
};

CWIAN.nextIteration = function () {
  this.time.delayedCall(2000, this.loadNextIteration, [], this);
};
/**
 *
 */
CWIAN.correctAnswer = function () {
  this.playCorrect();
};
/**
 *
 */
CWIAN.wrongAnswer = function () {
  this.playWrong();
};
/**
 *
 */
CWIAN.loadData = function () {
  this.iterationsData = null;
  const { categoriesNames } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const holder = [];
  const { items } = this.gameConfig;
  for (const categoryId in items) {
    const itemsList = items[categoryId];
    for (const itemId in itemsList) {
      const itemData = itemsList[itemId];
      holder.push({ categoryId, itemId, text: itemData.text });
    }
  }
  holder.sort((a, b) => Math.random() - 0.5);

  const rndNumber = Math.floor(Math.random() * categoriesNames.length);
  for (let i = 0; i < holder.length; i++) {
    if (holder[i].categoryId === categoriesNames[rndNumber]) {
      this.iterationsData = holder[i];
      break;
    }
  }
};
/**
 *
 */
CWIAN.getCurrentIterationCategory = function () {
  return this.iterationsData.categoryId;
};
/**
 *
 */
CWIAN.getCategoryItems = function () {
  return this.categoryItems;
};

export default EDC.Games.CategorizationSimpleFrame.Scenes.Main;
